import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.slice.js";
import { match } from 'ts-pattern';
import { useTranslation } from '@applyboard/ui-utils';
/**
 * Returns formatted dates and additional information about
 * an intake and its status. For break down of colours used
 * see: https://applyboard.atlassian.net/browse/APA-1776
 */
export function useFormattedIntakeDetails(_ref) {
  var startDate = _ref.startDate,
    intake = _ref.intake;
  var _useTranslation = useTranslation('useFormattedIntakeDetails'),
    t = _useTranslation.t;
  if (!startDate) {
    return {
      formattedDate: '--'
    };
  }
  var date = new Date(startDate);
  var options = {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC'
  };
  var formattedDate = date.toLocaleDateString('en-US', options);
  if (!intake) {
    return {
      formattedDate: formattedDate
    };
  }
  var formattedStatus = intake.intakeStatus.charAt(0).toUpperCase() + intake.intakeStatus.slice(1).replace('_', ' ');
  var statusDetails = match(intake.intakeStatus)["with"]('open', 'open_conditionally', function () {
    return {
      infoText: t('open'),
      intent: 'positive',
      contrast: 'mid'
    };
  })["with"]('will_open', 'will_open_conditionally', function () {
    return {
      infoText: t('willOpen'),
      intent: 'positive',
      contrast: 'mid'
    };
  })["with"]('likely_open', function () {
    return {
      infoText: t('likelyOpen'),
      intent: 'positive',
      contrast: undefined
    };
  })["with"]('waitlist', function () {
    return {
      infoText: t('waitlistOrClosed'),
      intent: 'warning',
      contrast: 'mid'
    };
  })["with"]('closed', 'closed_conditionally', function () {
    return {
      infoText: t('waitlistOrClosed'),
      intent: 'negative',
      contrast: 'mid'
    };
  }).otherwise(function () {
    return null;
  });
  return {
    formattedDate: formattedDate,
    status: {
      intent: statusDetails === null || statusDetails === void 0 ? void 0 : statusDetails.intent,
      infoText: statusDetails === null || statusDetails === void 0 ? void 0 : statusDetails.infoText,
      label: formattedStatus,
      contrast: statusDetails === null || statusDetails === void 0 ? void 0 : statusDetails.contrast
    }
  };
}